import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { DropTarget } from 'react-dnd';
import { dropTargetFactory, dropCollect } from './breadcrumbDragDrop';

const BreadcrumbSpan = styled.span.attrs({
  'aria-dropeffect': 'move',
  draggable: 'false',
})`
  cursor: pointer;
  border-radius: 5px;
  border: 1px solid ${({ isOver }) => (isOver ? '#526489' : 'transparent')};
  background-color: ${({ isOver }) => (isOver ? '#DCE0EA' : 'white')};
  color: ${({ isOver }) => (isOver ? '#000' : '#767676')};
`;

const BreadcrumbLink = ({
  children,
  parentPath,
  part,
  isOver,
  connectDropTarget,
  onClick,
}) => {
  return connectDropTarget(
    <span>
      <BreadcrumbSpan isOver={isOver} onClick={() => onClick(parentPath, part)}>
        {children}
      </BreadcrumbSpan>
    </span>,
  );
};

BreadcrumbLink.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  parentPath: PropTypes.string,
  part: PropTypes.string,
  connectDropTarget: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
};

const breadcrumbTarget = dropTargetFactory(
  (objectIdsToMove, { parentPath, part, onDrop }) => {
    onDrop(objectIdsToMove, parentPath, part);
  },
);

const DroppableBreadcrumbLink = DropTarget(
  'FSObject',
  breadcrumbTarget,
  dropCollect,
)(BreadcrumbLink);

export default DroppableBreadcrumbLink;

export { BreadcrumbSpan };
